module.exports = __webpack_public_path__ + "static/2-9a6a8cbbc47c4ebac33ac70512e73d73.jpg";